import { AZIENDAREALTIME} from './AziendaRealTimeTypes'

const initialState = {
    aziendaRealTime: ""
}

const AziendaRealTimeReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case AZIENDAREALTIME:
            
            return {
                aziendaRealTime: action.load
            }
    
        default:
          return state
    }

}


export default  AziendaRealTimeReducer;